import {Dimensions} from 'react-native';
import {DeviceInfo} from 'qunar-react-native';
import '@qnpm/react-native-ext-fetch';


export const isIOS = DeviceInfo.isIOS;
export const scheme = DeviceInfo.scheme;
export const platform = isIOS ? 'ios' : 'android';

// qp包版本号，默认取不到的时候为 -1
let qpVer = '-1';
DeviceInfo.getInfo(function (result) {
    if (result && result.qpInfo) {
        qpVer = result.qpInfo.version;
    }
});

//判断两个值是否相等
const is = (x, y) => {

    if (x === y) {
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    }
    return x !== x && y !== y;
};

/**
 * @description 自定义比较层级的比较方法
 * @param {Number} type 不传该参数表示深度比较，0: 浅比较 1: 深入比较1层,
 * 以此类推
 * @return {Function} 比较函数
 * @example
 * 1. 深度比较
 * const deepEqual = equal();
 * deepEqual({}, {});
 *
 * 2. 浅比较
 * const shallowEqual = equal(0);
 *
 * 3. 自定义比较层级
 * const equalX = equal(x);
 */
export const equal = type => {

    const compareRatio = type == null ? Infinity : +type + 1;
    const compare = (a, b, ratio = 0) => {
        //基本数据类型比较
        if (is(a, b)) {
            return true;
        }

        //如果a, b都是函数，则直接返回true，规避传入组件时这些不推荐的写法
        //1. <Component handler = {() => {}}/>
        //2. <Component handler = {this.xxxHandler.bind(this)}/>
        //造成的组件重新渲染
        if (typeof a === 'function' && typeof b === 'function') {
            return true;
        }

        //不是对象，又不相等，自然返回false
        if (typeof a !== 'object' || a === null || typeof b !== 'object' || b === null) {
            return false;
        }
        //对象比较
        if (compareRatio > ratio) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            const keysALength = keysA.length;
            if (keysALength !== keysB.length) {
                return false;
            }
            ratio = ratio + 1;
            return keysA.reduce((num, key) => {
                if (compare(a[key], b[key], ratio)) {
                    return ++num;
                }
            }, 0) === keysALength;

        }
        return false;
    };

    return compare;

};


//深入1层比较
export const equalInner = equal(1);

/**
 * 获取是否是 iPhone X 系列
 * @returns 是否是 iPhone X 系列
 */
export function isIphoneX() {
    return window.hysdk && window.hysdk.sniff.iphoneX;
}

export function notchHeight() {
    const immersiveInfo = window.hysdk && hysdk.sniff.qunar && hysdk.systemInfo && JSON.parse(hysdk.systemInfo).immersiveInfo;
    if (!immersiveInfo) {
        return 20;
    }
    const offset = immersiveInfo.immersiveOffset;
    return offset > 0 ? offset : 0;
}


/**
 * NOTCH_HEIGHT: 凹屏刘海的高度
 * NAVBAR_HEIGHT: NavigationBar 的高度
 * @type {number}
 */
export const NOTCH_HEIGHT = notchHeight();
export const NOTCH_PHONE = NOTCH_HEIGHT >= 40;

export const NAVBAR_HEIGHT_HEAD = 44;
export const NAVBAR_HEIGHT = NOTCH_HEIGHT + NAVBAR_HEIGHT_HEAD;
/**
 * 折叠屏适配
 * 屏幕尺寸
 */
export const getScreenSize = () => {
    return { width: window.innerWidth, height: window.innerHeight }
};

/**
 * 判断是否是空对象
 */
export function isValidObject(param) {
    return Object.prototype.isPrototypeOf(param) && !!Object.keys(param).length;
}

export function isFunction(func) {
    return typeof func == 'function' || false;
}

export const scroll = (scrollEle, scrollTop, cb) => {
    const top = scrollEle.scrollTop || 0;
    const startTime = new Date().getTime();
    const duration = 300; // ms

    function run () {
        const time = +new Date() - startTime;

        if (time >= duration) {
            scrollEle.scrollTo(0, scrollTop);
            window.cancelAnimationFrame(run.timer);
            // 最后一次滚动的时长
            setTimeout(() => {
                cb && cb()
            },150);
            return;
        }

        scrollEle.scrollTo(0, top + (scrollTop - top) * (time / duration));

        run.timer = window.requestAnimationFrame(run);
    }

    window.requestAnimationFrame(run);
};

let lockedKeys = {};

export function clickable(key) {
    if (lockedKeys[key]) {
        return false;
    }

    let lockTimer = setTimeout(function () {
        delete lockedKeys[key];
    }, 500);

    lockedKeys[key] = lockTimer;

    return true;
}


export function scale(num) {

    var baseWidth = getScreenSize().width > 500 ? 375 : getScreenSize().width;
    var fontSize = (baseWidth / 375) * 100;
    // iphone5会出现搜索模块和低价模块太靠近的情况，进行适配。
    fontSize = Math.max(fontSize, 100);

    return parseInt(fontSize * num / 100)
}

function  calSource() {
    let ua = navigator.userAgent.toLowerCase();
    let source = 'web';

    if (/(qunar)/ig.test(ua)) {
        // 在大客户端里
        if (/(qunariphone)/ig.test(ua)) {
            source = 'ios';
        }
        if (/(qunaraphone)/ig.test(ua)) {
            source = 'adr';
        }
    } else {
        // 在web端
        source = 'web';
        if (/(android)/ig.test(ua)) {
            source += 'adr';
        }
        if (/(iphone)/ig.test(ua)) {
            source += 'ios';
        }
    }
    return source;
}

export function logPageTime({r, time}) {
    let source = calSource();
    let p = window.__page_id + '_' + source;

    GodEye.log({
        p,
        r,
        t_ut: time
    });
}


export function getCookie (key, cookie) {
    let Cookie = cookie || document.cookie;
    let Reg = new RegExp(key + '=(.*?)(;|$)');
    let result = Cookie.match(Reg);
    if (result && result.length > 2) {
        return result[1];
    } else {
        return '';
    }
}
